import type { ComponentProps } from 'react';

import { Button } from '@change/ds-core-ui';

import { Translate, useI18n } from '@change-corgi/core/react/i18n';

import { ActionBarSunrise } from '../ActionBarSunrise';

export const StepActions: React.FC<StepActionsProps> = ({ disabled, loading, onPrimaryAction, ...rest }) => {
	const { translate } = useI18n();
	const loadingLabel = translate('corgi.petition.starter_onboarding.loading');

	return (
		<ActionBarSunrise {...rest}>
			<div className="flex flex-1 justify-end">
				<Button
					data-qa="next-step-button"
					type="button"
					variant="primary"
					onClick={onPrimaryAction}
					disabled={disabled}
				>
					{loading && <span className="sr-only">{loadingLabel}</span>}
					<Translate value="corgi.petition.starter_onboarding.components.step_actions.next_step" />
				</Button>
			</div>
		</ActionBarSunrise>
	);
};

type OnClick = ComponentProps<typeof Button>['onClick'];
type StepActionsProps = {
	disabled?: boolean;
	loading?: boolean;
	onPrimaryAction: OnClick;
} & ComponentProps<typeof ActionBarSunrise>;
